import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Filter.scss';

class Filter extends React.Component {
    constructor(props) {
        super(props);

        this.filter = React.createRef();

        this.state = {
            active: false,
        };
    }

    componentDidMount() {
        document.addEventListener(
            'click',
            this.handleClickOutside.bind(this),
            true
        );
    }

    componentWillUnmount() {
        document.removeEventListener(
            'click',
            this.handleClickOutside.bind(this),
            true
        );
    }

    handleClickOutside = (e) => {
        const filter = this.filter.current;

        if (!filter || !filter.contains(e.target)) {
            this.setState({
                active: false,
            });
        }
    };

    toggleActive = () => {
        this.setState((prevState) => ({
            active: !prevState.active,
        }));
    };

    render() {
        const { filters, filter, filterType, updateFilter } = this.props;
        const { active } = this.state;

        let label = this.props.label;

        if (filter !== -1) {
            label = 'Visa alla';
        }

        return (
            <div
                className={classNames('Filter', {
                    'Filter--Active': active,
                })}
                ref={this.filter}>
                <ul className="Filter__List" onClick={this.toggleActive}>
                    <li
                        className={classNames('Filter__Item', {
                            'Filter__Item--Active': filter === -1,
                        })}
                        data-filter={-1}
                        data-filter-type={filterType}
                        onClick={updateFilter}>
                        {label}
                    </li>
                    {filters.map((item, index) => (
                        <li
                            className={classNames('Filter__Item', {
                                'Filter__Item--Active': item.id === filter,
                            })}
                            data-filter={item.id}
                            data-filter-type={filterType}
                            key={index}
                            onClick={updateFilter}
                            dangerouslySetInnerHTML={{ __html: item.name }}
                        />
                    ))}
                </ul>
            </div>
        );
    }
}

Filter.propTypes = {
    educations: PropTypes.array,
    educationCategories: PropTypes.array,
    filters: PropTypes.array,
    filter: PropTypes.number,
    filterType: PropTypes.string,
    updateFilter: PropTypes.func,
    label: PropTypes.string,
};

Filter.defaultProps = {
    filters: [],
};

export default Filter;
